module.exports = __webpack_public_path__ + "img/icon-map-marker.381e96cb.svg";